import React from "react";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import "./index.css";


export const Main = () => {
  return (
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
};
